export default "__VITE_ASSET__CJemcibJ__"